import React from "react";
import { Button } from "antd";

import { Icons } from "components/layout";
import useWindowDimensions from "components/use-hooks/use-window-dimensions";
import Localize from "./localize";
import ModalStandard from "./modal-standard";


const SortModalStandard = ({
        wrapClass = "",
        modalClass = "",
        children
    }) => {

    const { width } = useWindowDimensions();

    return(
        <div className={`sort-modal-wrap ${ wrapClass }`}>
            <ModalStandard
                extraClass={ `sort-modal ${ modalClass }`}
                title={ <Localize>GLOBAL.Modal_Title_SortBy</Localize> }
                centered={ !(width <= 768) }
                modalButton={
                    <Button type="ghost">
                        <Icons.Sort />
                        <Localize wrap>GLOBAL.Button_Text_Sort</Localize>
                    </Button>
                }
            >
                { children }
            </ModalStandard>
        </div>
    );
};

export default SortModalStandard;
